export const seoNavigationPathPattern =
  /^\/(?:alternatives|articles|features|for|guides|materials|products|solutions)(?:\/|\?|$)/

export const navigationFallbackDenylist = [
  /^\/api(?:\/|$)/,
  /^\/\.well-known(?:\/|$)/,
  seoNavigationPathPattern,
  /^\/(?:robots\.txt|sitemap\.xml)$/,
] as const
